import type { TOC } from '@ember/component/template-only'
import { on } from '@ember/modifier'
import { or, eq, not, and } from 'ember-truth-helpers'
import { t } from 'ember-intl'
import { pick } from 'teacher-ui-client/helpers/pick'
import type Teacher from 'teacher-ui-client/models/teacher'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'
import type { AdditionalTeacherSelectOption } from 'teacher-ui-client/components/base/select/teacher/options'
import { BaseSelect } from 'teacher-ui-client/components/base/select'

interface Signature {
  Element: HTMLSelectElement
  Args: {
    placeholder?: string
    additionalOptions?: AdditionalTeacherSelectOption[]
    teachers: Teacher[]
    teacherId?: string
    updateTeacherId: (teacherId: string) => unknown
    themeKey?: ThemeKeys
  }
  Blocks: {
    default: []
  }
}
// A themed select component.
// Uses native select hence does not support styling of options.
export const TeacherSelect: TOC<Signature> = <template>
  <BaseSelect
    data-test-teacher-select
    @themeKey={{@themeKey}}
    {{on "input" (pick "target.value" @updateTeacherId)}}
    ...attributes
  >
    {{#if (and @placeholder (not @teacherId))}}
      <option value="" selected={{not @teacherId}} disabled={{@teacherId}}>{{@placeholder}}</option>
    {{/if}}
    {{#each @additionalOptions as |optionItem|}}
      <option value={{optionItem.id}} selected={{eq @teacherId optionItem.id}}>
        {{or optionItem.label (if optionItem.labelKey (t optionItem.labelKey))}}
      </option>
    {{/each}}
    <optgroup label={{t "base.select.teachers"}}>
      {{#each @teachers as |teacher|}}
        <option value={{teacher.id}} selected={{eq @teacherId teacher.id}}>{{teacher.fullName}}</option>
      {{/each}}
    </optgroup>
  </BaseSelect>
</template>

export default TeacherSelect
